import {Fragment} from "react";
import {defineMessage} from "react-intl";
import Dialog from "./Dialog";
import FormattedButton from "../../FormattedButton";
import {useBoolState} from "../../../hooks";

type Props = {
    domainId: number;
    onSuccess: () => void;
};

export default (props: Props) => {
    const {domainId, onSuccess} = props;

    const [show, setShowOn, setShowOff] = useBoolState();

    return (
        <Fragment>
            <FormattedButton
                onClick={setShowOn}
                message={defineMessage({id: "new_pickup_group", defaultMessage: "New pickup group"})}
            />
            <Dialog domainId={domainId} onSuccess={onSuccess} show={show} close={setShowOff} />
        </Fragment>
    );
};
